import { connect } from 'react-redux';
import React from 'react';
import { parse, stringify } from 'query-string';
import { finishAuthenticateWithOauth } from 'app/models/auth/actions';
import { withHistory } from 'app/components/router/History';
import { History } from 'app/services/history';
import { AppDispatch } from 'redux';
import { LoginRoute } from 'app/constants/Routes';
import { setFlash } from 'app/services/flash';
import { parseUrlLoose } from 'app/utils/LooseURL';
import { notify } from 'app/services/errorReporter';
import { OauthLoginResult } from 'app/services/oauth/login';
import { IResult } from 'app/components/auth/GetOauthResult';

interface IProps {
  history: History;
  finishAuthenticateWithOauth: () => Promise<OauthLoginResult>;
}

class OauthLoginCallback extends React.Component<IProps> {
  public componentDidMount() {
    void this.onContinueOauth();
  }

  public render() {
    return null;
  }

  private async onContinueOauth() {
    const { history } = this.props;
    let nextUri = LoginRoute.getPathname();
    let flashResult: IResult;

    try {
      const result = await this.props.finishAuthenticateWithOauth();
      nextUri = result.redirectUriReference;

      if (result.success) {
        flashResult = { success: true };
      } else {
        flashResult = { success: false, error: result.error };
      }
    } catch (error) {
      notify(error, { name: 'OauthLoginCallback' });
      flashResult = { success: false, error };
    }

    history.replace(addResultKey(nextUri, setFlash(flashResult)));
  }
}

function addResultKey(url: string, resultKey: string): string {
  const newUrl = parseUrlLoose(url);
  const search = stringify({
    ...parse(newUrl.search),
    resultKey,
  });
  return `${newUrl.pathname}?${search}${newUrl.hash}`;
}

const mapDispatchToProps = (dispatch: AppDispatch) => ({
  finishAuthenticateWithOauth: () =>
    dispatch(finishAuthenticateWithOauth()),
});

export default withHistory(connect(null, mapDispatchToProps)(OauthLoginCallback));
